<template>
    <div class="page-cards">
        <el-dialog
                title="Добавить карту"
                :visible.sync="addVisible"
                width="436px"
        >
            <div>
                <el-form class="m-t-10" ref="validationForm" :model="model" v-loading="loading">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="ID" prop="ID" :rules="[{ required: true, message: 'ID не заполнен' }]">
                                <el-input v-model="model.ID" placeholder="ID карты"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Тип карты" prop="Type">
                                <el-select :clearable="true" v-model="model.Type" placeholder="Тип карты" class="w-100">
                                    <el-option
                                            v-for="item in cardTypeDict"
                                            :key="item.ID"
                                            :label="item.Name"
                                            :multiple="false"
                                            :value="item.ID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="Компания">
                                <el-select :clearable="true" v-model="model.CompanyID" placeholder="Выберите компанию" class="w-100">
                                    <el-option
                                            v-for="item in companyDict"
                                            :key="item.ID"
                                            :label="item.Name"
                                            :multiple="false"
                                            :value="item.ID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Клиент">
                                <el-select :clearable="true" v-model="model.CustomerID" placeholder="Выберите клиента" class="w-100">
                                    <el-option
                                            v-for="item in customers"
                                            :key="item.ID"
                                            :label="item.Name"
                                            :multiple="false"
                                            :value="item.ID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="Тип клиента">
                                <el-select :clearable="true" v-model="model.CustomerType" placeholder="Тип клиента" class="w-100">
                                    <el-option
                                            v-for="item in [{ ID: 1, Name: 'Разовый' }, { ID: 2, Name: 'Постоянный' }]"
                                            :key="item.ID"
                                            :label="item.Name"
                                            :multiple="false"
                                            :value="item.ID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Группа клиента">
                                <el-select :clearable="true" v-model="model.CustomerGroup" placeholder="Группа клиента" class="w-100">
                                    <el-option
                                            v-for="item in $customerGroupDict"
                                            :key="item.ID"
                                            :label="item.Name"
                                            :multiple="false"
                                            :value="item.ID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="Тариф">
                                <el-select :clearable="true" v-model="model.TariffID" placeholder="Выберите тариф" class="w-100">
                                    <el-option
                                            v-for="item in $tarifDict"
                                            :key="item.ID"
                                            :label="item.Name"
                                            :multiple="false"
                                            :value="item.ID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Зона">
                                <el-select :clearable="true" v-model="model.ZoneID" placeholder="Укажите зону" class="w-100">
                                    <el-option
                                            v-for="item in $zonesDict"
                                            :key="item.ID"
                                            :label="item.Name"
                                            :multiple="false"
                                            :value="item.ID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="Срок действия" prop="TimeExpiration">
                                <el-date-picker
                                        class="w-100"
                                        v-model="model.TimeExpiration"
                                        type="datetime"
                                        placeholder="Срок действия"
                                        :picker-options="{ firstDayOfWeek: 1 }"
                                >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="" prop="PassageControl" class="m-b-0">
                                <el-checkbox class="m-l-0" v-model="model.PassageControl">Контроль проезда</el-checkbox>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" align="right" class="d-flex align-items-right">
                            <el-button type="primary" class="w-100" icon="el-icon-plus" @click="add" :loading="loading">Добавить</el-button>
                        </el-col>
                    </el-row>
                </el-form>

            </div>
        </el-dialog>

        <el-card v-if="$loginType() !== 4" shadow="never" class="m-b-20">
            <el-row :gutter="20">
                <el-col :sm="24" :md="12" :lg="18" :xl="18" class="m-b-10 m-b-md-0">
                    <el-input
                              class="w-100"
                              placeholder="Искать карту"
                              v-model="form.SearchString"
                              v-on:change="getData"
                              clearable>
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </el-col>
                <el-col :sm="24" :md="12" :lg="6" :xl="6" align="right" class="d-flex">
                    <el-button class="w-50" type="primary" @click="handleFilter" icon="icon-search">Поиск</el-button>
                    <el-button class="w-50" @click="addForm" icon="icon-plus">Добавить</el-button>
                </el-col>
            </el-row>
        </el-card>
        <el-row :gutter="20">
            <el-col :span="24">
                <el-table v-loading="loading" :data="dataTable">
                    <el-table-column prop="ID" label="Номер">
                        <template slot-scope="scope">
                            <div class="font-weight-bold">
                                <a href="#" @click.prevent="showDetails(scope.row.ID)" class="color-black">
                                    {{scope.row.Name}}
                                </a>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="TimeExpiration" label="Срок истекает" v-if="$mobile()">
                        <template slot-scope="scope">
                            {{ scope.row.TimeExpiration | date }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="TariffID" label="Тариф" v-if="$mobile()">
                        <template slot-scope="scope" v-if="tarifDict && tarifDict.find(x => x.ID == scope.row.TariffID)">
                            {{ tarifDict.find(x => x.ID == scope.row.TariffID).Name }}
                        </template>
                    </el-table-column>
<!--                    <el-table-column-->
<!--                        v-if="$loginType() === 4"-->
<!--                        label="Оплата"-->
<!--                        width="80px"-->
<!--                    >-->
<!--                        <template slot-scope="scope">-->
<!--                            <el-button @click="$router.push({ name: 'payCard', query: { cardId: scope.row.ID }})" icon="icon-payment-card" class="el-button&#45;&#45;icon" size="mini" title="Оплатить"></el-button>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                    <el-table-column
                            v-if="$loginType() === 1"
                            fixed="right"
                            label=""
                            width="80px"
                            align="right"
                    >
                        <template slot-scope="scope">
                            <el-button @click="deleteItem(scope.row.ID)" icon="icon-trash" class="el-button--icon" size="mini" title="Удалить"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="m-t-20 text-center">
                    <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="form.Page"
                            :page-sizes="[10, 20, 100, 200, 300, 400]"
                            :page-size="form.PageSize"
                            layout="sizes, prev, pager, next, total"
                            :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import Vue from 'vue'

    export default {
        data () {
            return {
                loading: false,
                form: {
                    From: Vue.moment().add(-30, 'days').format('DD/MM/YYYY HH:mm'),
                    To: Vue.moment().hour('23').minutes('59').format('DD/MM/YYYY HH:mm'),
                    SearchString: '',
                    Page: 1,
                    PageSize: 20
                },
                total: 0,
                dataTable: [],
                tarifDict: [],
                addVisible: false,
                editMode: false,
                model: {},
                companyDict: [],
                cardTypeDict: [],
                customers: []
            }
        },
        created () {
            this.getCustomers()
            this.getCardTypes()
            this.getCompanies()
            this.getTarif()
            this.getData()
        },
        methods: {
            changeDate (date) {
                this.form.From = date[0]
                this.form.To = date[1]
                this.getData()
            },
            handleSizeChange (val) {
                this.form.PageSize = val
                this.getData()
            },
            handleCurrentChange (val) {
                this.form.Page = val
                this.getData()
            },
            handleFilter () {
                this.getData()
            },
            getData () {
                this.loading = true

                let request = Object.assign({
                    Name: "GetItemsList",
                    ItemType: "Card"
                }, this.form)

                this.$api.Main.getCards(request).then(response => {
                    this.loading = false
                    this.dataTable = response.Items
                    this.total = response.Total
                }).catch (() => {
                    this.loading = false
                })
            },
            showDetails (id) {
                console.log(id)
                this.$router.push({ name: 'cardDetails', params: { id: id } })
            },
            getTarif () {
                this.$api.Main.getTarif().then(response => {
                    this.tarifDict = response.Items
                })
            },
            add () {
                this.$refs['validationForm'].validate((valid) => {
                    if (valid) {
                        this.clearFormErrors('validationForm')
                        this.loading = true

                        let request = Vue.$props('AddItem', 'Card', this.model)

                        this.$api.Main.addCard(request).then(response => {
                            this.loading = false

                            if (response.Result === "Success") {
                                this.resetForm()
                                this.$message({
                                    message: 'Карта добавлена',
                                    type: 'success',
                                    res: response
                                })

                                this.addVisible = false
                                this.getData()

                                setTimeout(() => this.clearFormErrors('validationForm'), 500)
                            }
                            else {
                                this.$message({
                                    message: response.ErrorString,
                                    type: 'error',
                                    res: response
                                })
                            }
                        }).catch((error) => {
                            this.loading = false
                            this.showFormErrors(error, 'validationForm')
                        })
                    }
                })
            },
            addForm () {
                this.resetForm()
                setTimeout(() => this.clearFormErrors('validationForm'), 1)
                this.editMode = false
                this.addVisible = true
            },
            close() {
                this.addVisible = false
                this.resetForm()
                setTimeout(() => this.clearFormErrors('validationForm'), 500)
            },
            resetForm () {
                this.model = {}
            },
            getCardTypes() {
                let request = Object.assign({
                    Name: "GetItemsList",
                    ItemType: "CardType",
                    OperatorName: "Admin"
                }, this.form)

                this.$api.Main.getCardTypes(request).then(response => {
                    this.cardTypeDict = response.Items
                }).catch (() => {

                })
            },
            getCompanies() {
                let request = Object.assign({
                    Name: "GetItemsList",
                    ItemType: "Company",
                    OperatorName: "Admin"
                }, this.form)

                this.$api.Main.getCompanies(request).then(response => {
                    this.companyDict = response.Items
                }).catch (() => {

                })
            },
            getCustomers () {
                let request = Object.assign({
                    Name: "GetItemsList",
                    ItemType: "Customer"
                }, this.form)

                this.$api.Main.getCustomers(request).then(response => {
                    this.customers = response.Items
                }).catch (() => {

                })
            },
            deleteItem (id) {
                this.$confirm('Вы уверены что хотите удалить карту?').then(() => {
                    let request = {
                        Name: "RemoveItem",
                        ItemType: "Card",
                        ItemId: id
                    }

                    this.$api.Main.deleteCustomer(request).then(response => {
                        if (response.Result === 'Failed') {
                            this.$message({
                                message: response.ErrorString,
                                type: 'error'
                            })
                        }
                        else {
                            this.$message({
                                message: 'Карта удалена',
                                type: 'success',
                                res: response
                            })
                            this.getData()
                        }
                    })
                })
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">

</style>
